import { recordGA4Event } from '@components/services/analytics/ga4'
import {
  AppsFlyerKeys,
  AppsFlyerParams,
  EmptyGuid,
  FacebookEvents,
  NEXT_CREATE_WISHLIST,
  NEXT_GET_PRODUCT,
} from '@components/utils/constants'
import {
  openLoginView,
  eventIdForFB,
  getCategories,
  getBrowserIdForFBConversion,
  getIpAddressForFBConversion,
  getDateOfBirthHash,
  getGenderHash,
  getCurrentPage,
  getCommonAppsFlyerValue,
  CURRENT_PAGE,
} from '@framework/utils/app-util'
import { getSHA256Hash } from '@framework/utils/cipher'
import { matchStrings } from '@framework/utils/parse-util'
import axios from '@services/axiosInterceptorInstance'
import { facebookEventHandler } from 'hooks/facebook-conversion'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { MO_ENGAGE_EVENT } from 'hooks/moengage_event.modal'

export const handleWishList = async ({
  productData,
  setQuickview,
  user,
  asPath,
  setSidebarView,
  closeSidebar,
  currentPage,
  deviceCheck,
  product,
  AF,
  enableHtmlScroll,
  insertToLocalWishlist,
  trackMoEngageEvent,
}: {
  asPath: string
  productData: any
  setQuickview: any
  deviceCheck: string
  user: any
  setSidebarView: any
  closeSidebar: any
  currentPage: CURRENT_PAGE | undefined
  product: any
  AF: any
  enableHtmlScroll: () => void
  trackMoEngageEvent: (
    eventName: MO_ENGAGE_EVENT,
    params?: Object | undefined,
    window?: any
  ) => void
  insertToLocalWishlist: (productData: any) => void
}) => {
  setQuickview(undefined)
  const accessToken = localStorage?.getItem('user')
  if (accessToken) {
    const createWishlist = async () => {
      try {
        const res = await axios.post(NEXT_CREATE_WISHLIST, {
          id: user.userId,
          productId: productData.recordId,
          flag: true,
        })
        if (res?.data) {
          insertToLocalWishlist(productData)
        }
      } catch (error) {
        console.error(':: error ', error)
      }
    }
    createWishlist()
  } else {
    openLoginView(asPath)
    setSidebarView('LOGIN_VIEW')
    closeSidebar()
    enableHtmlScroll()
    // insertToLocalWishlist()
  }

  let productAvailability = 'Yes'
  if (productData?.currentStock > 0) {
    productAvailability = 'Yes'
  } else {
    productAvailability = 'No'
  }

  trackMoEngageEvent(
    MO_ENGAGE_EVENT.ADD_TO_WISHLIST,
    {
      URL: window?.location?.href,
      Product_name: productData?.name,
      Product_category: productData?.classification?.mainCategoryName,
      Product_category_2: productData?.classification?.category,
      Product_color: productData?.variantGroupCode,
      Price: productData?.price?.raw?.withTax,
    },
    window
  )

  let item_variant = ''
  if (productData?.attributes?.length) {
    item_variant = productData?.attributes.find(
      (x: any) => x?.key === 'productData.colours'
    )?.value
  } else if (productData?.customAttributes?.length) {
    item_variant = productData?.customAttributes.find(
      (x: any) => x?.key === 'productData.colours'
    )?.value
  }
  const eventId = eventIdForFB()

  recordGA4Event(window, GA_EVENT.ADD_TO_WISHLIST, {
    ecommerce: {
      items: [
        {
          item_name: productData?.name,
          item_brand: productData?.brand,
          item_category2: getCategories(productData).category2,
          item_category: getCategories(productData).category,
          item_variant: productData?.customAttributes?.find(
            (x: any) => x?.key === 'global.colour'
          )?.valueText,
          color: productData?.customAttributes?.find(
            (x: any) => x?.key === 'global.colour'
          )?.valueText,
          quantity: 1,
          item_id: productData?.sku,
          // item_size: getlineItemSizeWithoutSlug(productData),
          price: productData?.price?.raw?.withTax,
          item_var_id: productData?.stockCode,
          item_list_name: getCategories(productData).category,
          index: 1,
        },
      ],
      item_var_id: productData?.stockCode,
      header: currentPage,
      device: deviceCheck,
      event_id: eventId,
      current_page: `${currentPage} Quick View`,
      availability: productAvailability,
      loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
    },
  })

  const mobileNumber = user?.mobile || user?.telephone
  let facebookeventData: any = {
    data: [
      {
        event_name: FacebookEvents.ADD_TO_WISHLIST,
        event_time: Math.floor(new Date().getTime() / 1000),
        event_id: eventId,
        action_source: 'website',
        user_data: {
          em: [user?.email ? await getSHA256Hash(user?.email) : ''],
          ph: mobileNumber ? await getSHA256Hash(mobileNumber) : null,
          fn: user?.firstName ? await getSHA256Hash(user?.firstName) : null,
          ln: user?.lastName ? await getSHA256Hash(user?.lastName) : null,
          client_user_agent: window.navigator.userAgent,
          fbp: getBrowserIdForFBConversion(),
          client_ip_address: (await getIpAddressForFBConversion()) || null,
          external_id: mobileNumber ? await getSHA256Hash(mobileNumber) : null,
          db: await getDateOfBirthHash(user),
          ge: await getGenderHash(user?.gender),
          ct: null,
          zp: null,
          country: await getSHA256Hash('in'),
        },
        custom_data: {
          currency: 'INR',
          content_name: getCurrentPage(),
          content_category: getCategories(product).category,
          content_ids: [product?.stockCode],
          content_type: 'product',
          contents: [
            {
              id: product?.recordId ?? product?.productId,
              quantity: 1,
              item_price: product?.price?.raw?.withTax,
              delivery_category: 'home_delivery',
            },
          ],
        },
      },
    ],
  }

  facebookEventHandler(facebookeventData)

  if (typeof AF !== 'undefined') {
    const commonEventValue = getCommonAppsFlyerValue()
    AF('pba', 'event', {
      eventType: 'EVENT',
      eventName: AppsFlyerKeys.AddToWishlist,
      eventRevenueCurrency: 'INR',
      eventValue: {
        [AppsFlyerParams.AFEventParam3]: 'Quick View',
        [AppsFlyerParams.AFEventParamContent]: productData?.name,
        [AppsFlyerParams.AFEventParamContentId]: productData?.stockCode,
        [AppsFlyerParams.AFEventParamPrice]:
          productData?.price?.raw?.withTax + '',
        [AppsFlyerParams.AFEventParam5]:
          product?.classification?.mainCategoryName || '',
        [AppsFlyerParams.AFEventParam6]:
          product?.classification?.category || '',
        ...commonEventValue,
      },
    })
  }
}

export const attributeChanged = ({
  fieldCode,
  value,
  obj,
  product,
  quickViewData,
  currentVariantData,
  setSelectedAttrData,
  setCurrentVariantData,
  setSelectedSizeVariant,
  setQuickViewData,
}: {
  fieldCode: string
  value: string
  obj: any
  product: any
  quickViewData: any
  currentVariantData: any
  setSelectedAttrData: (payload: any) => void
  setCurrentVariantData: (payload: any) => void
  setSelectedSizeVariant: (payload: any) => void
  setQuickViewData: (value: any) => void
}) => {
  let slug = ''

  const variantProductFilter = (vps: any[], fc: string, v: string) => {
    const checkCorrectAttribute = (vpas: any) =>
      vpas.filter((vpa: any) => vpa.fieldCode === fc && vpa.fieldValue === v)
    const optionsWithCorrectAttribute = vps.filter(
      (vp: any) => checkCorrectAttribute(vp.attributes).length > 0
    )
    return optionsWithCorrectAttribute
  }

  const currentSizeAndColor = {
    'global.colour': product?.customAttributes?.filter(
      (attr: any) => attr?.key === 'global.colour'
    )[0]?.value,
    'clothing.size': product?.customAttributes?.filter(
      (attr: any) => attr.key === 'clothing.size'
    )[0]?.value,
  }

  if (matchStrings(fieldCode, 'clothing.size', true)) {
    currentSizeAndColor['clothing.size'] = value
    setCurrentVariantData(currentSizeAndColor)
    const variantsThatMatchColorAndSize = variantProductFilter(
      quickViewData?.variantProducts,
      'clothing.size',
      value
    )[0]
    const currentProductCustomAttribsCleaned = product.customAttributes.filter(
      (ca: any) => !(ca.key === 'clothing.size' || ca.key === 'global.colour')
    )

    if (variantsThatMatchColorAndSize?.productId) {
      const updatedProduct = {
        ...quickViewData,
        ...{
          productId: variantsThatMatchColorAndSize?.productId,
          stockCode: variantsThatMatchColorAndSize.stockCode,
          currentStock: variantsThatMatchColorAndSize.currentStock,
        },
      }
      setSelectedAttrData({ ...updatedProduct })
      setQuickViewData({ ...updatedProduct })

      setSelectedSizeVariant(variantsThatMatchColorAndSize)
    }
  } else {
    if (matchStrings(fieldCode, 'global.colour', true)) {
      const handleAsync = async (slug: string) => {
        const { data: difColoredProd }: any = await axios.post(
          NEXT_GET_PRODUCT,
          { slug: slug }
        )
        currentSizeAndColor['global.colour'] = value
        currentSizeAndColor['clothing.size'] =
          currentVariantData['clothing.size']
        setCurrentVariantData(currentSizeAndColor)
        const variantsthatMatchSizeAndColor = variantProductFilter(
          difColoredProd?.product?.variantProducts,
          'clothing.size',
          currentVariantData['clothing.size']
        )[0]
        const newStockCode = variantsthatMatchSizeAndColor?.stockCode
        const updatedProduct = {
          ...difColoredProd?.product,
          ...{
            productId: variantsthatMatchSizeAndColor?.productId,
            stockCode: variantsthatMatchSizeAndColor?.stockCode,
            currentStock: variantsthatMatchSizeAndColor?.currentStock,
          },
        }

        setSelectedAttrData({ ...updatedProduct })
        setQuickViewData({ ...updatedProduct })
      }

      slug = obj?.slug.substring(obj?.slug.indexOf('/') + 1)
      handleAsync(slug)
    }
  }
}
